export default __webpack_public_path__ + "static/media/trener9.5eff6112.png";